"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _modal_1 = tslib_1.__importDefault(require("../_components/_modal"));
var anqCommonModal_1 = tslib_1.__importDefault(require("./anqCommonModal"));
var anqDelayModal_1 = tslib_1.__importDefault(require("./anqDelayModal"));
var anqInfoModal_1 = tslib_1.__importDefault(require("./anqInfoModal"));
var AnqModal = _modal_1.default;
AnqModal.CommonModal = anqCommonModal_1.default;
AnqModal.InfoModal = anqInfoModal_1.default;
AnqModal.DelayModal = anqDelayModal_1.default;
exports.default = AnqModal;
//# sourceMappingURL=index.js.map